import { ApLedgerRecord, QboBillRecord } from '../../../api/types';
import { parseDatePreservingCalendar } from '../../../utils/formatDate';

const formatRecordType = (value?: string) => value ? value.replace(/_/g, ' ') : '—';

export const formatApLedgerRecordType = (item: ApLedgerRecord) => {
    const displayType = String(item.display_record_type || '').trim().toLowerCase();
    if (displayType === 'recurring' || displayType === 'upcoming obligation') {
        return 'Recurring';
    }
    if (displayType === 'bill obligation') {
        return 'Bill Due';
    }
    if (displayType === 'document' || displayType === 'bill support') {
        return 'Bill Support';
    }
    if (displayType === 'payment history' || displayType === 'paid obligation') {
        return 'Payment';
    }
    if (displayType === 'bank disbursement' || displayType === 'bank outflow') {
        return 'Bank Disbursement';
    }
    return item.display_record_type || formatRecordType(item.record_type);
};

export const formatApLedgerReference = (item: ApLedgerRecord) => {
    const referenceLabel = String(item.reference_label || '').trim();
    if (referenceLabel) {
        return referenceLabel;
    }
    const referenceNo = String(item.reference_no || '').trim();
    if (referenceNo.includes('::ap_bill::')) {
        const suffix = referenceNo.split('::ap_bill::')[1]?.trim();
        if (suffix) {
            return `Bill #${suffix}`;
        }
        return 'Bill';
    }
    if (referenceNo.includes('::')) {
        return '—';
    }
    return referenceNo || '—';
};

export const getApBillListStatus = (bill: QboBillRecord): string => {
    const balanceDue = Number(bill.data?.balance_due || 0);
    if (balanceDue <= 0) return 'paid';
    const dueDateValue = bill.data?.due_date;
    const dueDate = dueDateValue ? parseDatePreservingCalendar(dueDateValue) : null;
    if (!dueDate) return 'open';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return dueDate < today ? 'overdue' : 'open';
};
